module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../node_modules/happypack/loader.js?id=jsx!./TransferView.js"));
	}, "PayMentTransfer");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=PayMentTransfer!./src/pages/Shop/PayMent/Transfer/TransferView.js
// module id = 891
// module chunks = 431